import React from 'react';
import './InfoBlock.css';

/**
 * InfoBlock Component
 * Info block with number and content
 * 
 * @param {string} number - Block number (e.g., "01")
 * @param {string} title - Block title
 * @param {string} text - Block description text
 * @param {string} className - Additional CSS classes
 */
const InfoBlock = ({ number, title, text, className = '' }) => {
  return (
    <div className={`info-block ${className}`}>
      <div className="info-number">{number}</div>
      <h2 className="info-title">{title}</h2>
      <p className="info-text">{text}</p>
    </div>
  );
};

export default InfoBlock;























